import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { WallboardService } from '../../../services/wallboard/wallboard.service';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.css']
})
export class TimeInputComponent implements OnInit {
  time: number;
  @Input() inputName: string;
  @Input() metric: string;
  @Input() color: string;
  @Input() metricvalue: any;
  @Output() valueChange = new EventEmitter();

  hours: string;
  minutes: string;
  seconds: string;
  constructor(public wallboardService: WallboardService) { }

  ngOnInit() {
    this.calcTime();
  }

  calcTime() {
    this.hours = this.padNum(Math.floor(this.metricvalue/3600), 2);
    this.minutes = this.padNum(Math.floor((this.metricvalue - (parseInt(this.hours) * 3600))/60), 2);
    this.seconds = this.padNum(this.metricvalue - (parseInt(this.hours) * 3600) - (parseInt(this.minutes) * 60), 2);
    this.valueChange.emit(this.metricvalue);
  }

  padNum(num: number, size: number) {
    var s = String(num);
    while (s.length < size) s = "0" + s;
    return s;
  }

  updateMetricValue(val){
    this.metricvalue = val;
    this.calcTime();
  }

}
